import Room1Img from './assets/img/gallery/2/DSC_1008.jpg';
import pic1_8 from './assets/img/gallery/1/DSC_3000-HDR.jpg'
import Room4Img from './assets/img/gallery/2/DSC_1079.jpg';
import Room5Img from './assets/img/gallery/2/DSC_1104.jpg';
import Room6Img from './assets/img/rooms/6.png';
import Room7Img from './assets/img/rooms/7.png';
import Room8Img from './assets/img/rooms/1.png';
import Room9Img from './assets/img/rooms/4.png';


import {
  FaWifi,
  FaCoffee,
  FaBath,
  FaParking,
  FaSwimmingPool,
  FaHotdog,
  FaStopwatch,
  FaCocktail,
} from 'react-icons/fa';

export const getRoomData = (t) => {
  return [
    {
      id: 1,
      name: t('jacuzziApt'),
      description: t('jacuzziAptdet'),
      facilities: [
        { name: 'Wifi', icon: <FaWifi /> },
        { name: t('Kawa'), icon: <FaCoffee /> },
        { name: t('Wanna'), icon: <FaBath /> },
        { name: t('DarmowyParking'), icon: <FaParking /> },
        { name: t('Basen'), icon: <FaSwimmingPool /> },
      ],
      size: 45,
      maxPerson: 8,
      price: 1150,
      image: Room1Img,
      imageLg: Room1Img,
    },
    {
      id: 2,
      name: t('apt1'),
      description: t('apt1det'),
      facilities: [
        { name: 'Wifi', icon: <FaWifi /> },
        { name: t('Kawa'), icon: <FaCoffee /> },
        { name: t('Wanna'), icon: <FaBath /> },
        { name: t('DarmowyParking'), icon: <FaParking /> },
        { name: t('Basen'), icon: <FaSwimmingPool /> }
      ],
      size: 45,
      maxPerson: 5,
      price: 220,
      image: pic1_8,
      imageLg: pic1_8,
    },
    {
      id: 3,
      name: t('apt3'),
      description: t('apt3det'),
      facilities: [
        { name: 'Wifi', icon: <FaWifi /> },
        { name: t('Kawa'), icon: <FaCoffee /> },
        { name: t('Wanna'), icon: <FaBath /> },
        { name: t('DarmowyParking'), icon: <FaParking /> },
      ],
      size: 90,
      maxPerson: 9,
      price: 220,
      image: Room4Img,
      imageLg: Room4Img,
    },
    {
      id: 4,
      name: t('apt4'),
      description: t('apt4det'),
      facilities: [
        { name: 'Wifi', icon: <FaWifi /> },
        { name: t('Kawa'), icon: <FaCoffee /> },
        { name: t('Wanna'), icon: <FaBath /> },
        { name: t('DarmowyParking'), icon: <FaParking /> },
      ],
      size: 90,
      maxPerson: 9,
      price: 220,
      image: Room5Img,
      imageLg: Room5Img,
    },
  ];
};

export const getPackageData = (t) => {
  return [
    {
      id: 1,
      type: 2,
      name: t('package1'),
      description: t('package1Desc'),
      price: '400 zł',
      link: '/pakiety/rodzinny_krakow',
      image: Room8Img,
    },
    {
      id: 2,
      type: 3,
      name: t('package2'),
      description: t('package2Desc'),
      price: '700 zł',
      link: '/pakiety/biznes_podwojny',
      image: Room9Img,
    },
    {
      id: 3,
      type: 3,
      name: t('package3'),
      description: t('package3Desc'),
      price: '380 zł',
      link: '/pakiety/biznes_pojedynczy',
      image: Room6Img,
    },
    {
      id: 4,
      type: 4,
      name: t('package4'),
      description: t('package4Desc'),
      price: '1880 zł',
      link: '/pakiety/sezon_wakacje',
      image: Room7Img,
    },
  ];
};
